import { render, staticRenderFns } from "./Alibaba-order-myself.vue?vue&type=template&id=5cef3deb&scoped=true&"
import script from "./Alibaba-order-myself.vue?vue&type=script&lang=js&"
export * from "./Alibaba-order-myself.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef3deb",
  null
  
)

export default component.exports